export const RedirectPageNoti = (contractId: string, productCode: string, history: any) => {
  switch (productCode) {
    case 'P_I':
      history.push({
        pathname: '/crafted/insurance/person-insurance-coop',
        state: {
          idContract: contractId,
        },
      })
      break
    default:
      break
  }
}
